"use client";

import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { BottomSheet, BottomSheetBody, classNames, FloatingCombobox, FloatingComboboxEmpty, FloatingComboboxInput, FloatingComboboxItem, FloatingComboboxItemAvatar, FloatingComboboxItemContent, FloatingComboboxItemTitle, FloatingComboboxList, ItemAvatar, ItemContent, ItemTitle, Media, SwitchPill, Tooltip, useIsLessThanMd } from "@opensea/ui-kit";
import { MoreHoriz } from "@opensea/ui-kit/icons";
import { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { useIsAbstractWalletAccount } from "../../hooks/useIsAbstractWalletAccount";
import { Avatar } from "../Avatar";
import { Item } from "../Item";
const PRIORITIZED_SWAP_CHAINS = ["ethereum", "solana", "abstract", "arbitrum", "base", "polygon", "ronin"];
export function ChainSelect(t0) {
  const $ = _c(17);
  const {
    direction,
    value,
    onSelectChain,
    className
  } = t0;
  const t = useTranslations("wallet.ChainSelect");
  const {
    chains,
    getLogo
  } = useChains();
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const isAbstractWallet = useIsAbstractWalletAccount();
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "fromCurrency"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fromCurrency = useWatch(t1);
  const selectedChain = chains.find(chain => chain.identifier === value);
  const isLessThanMd = useIsLessThanMd();
  const visibleChainIndex = isLessThanMd ? 5 : 7;
  const prioritizedChains = PRIORITIZED_SWAP_CHAINS.reduce((acc, id) => {
    const match = chains.find(chain_0 => chain_0.identifier === id);
    if (match) {
      acc.push(match);
    }
    return acc;
  }, []);
  const remainingChains = chains.filter(_temp);
  let allChains = [...prioritizedChains, ...remainingChains];
  if (selectedChain && !PRIORITIZED_SWAP_CHAINS.includes(selectedChain.identifier)) {
    const selectedChainIndex = allChains.findIndex(chain_2 => chain_2.identifier === selectedChain.identifier);
    if (selectedChainIndex >= visibleChainIndex) {
      allChains = allChains.filter(chain_3 => chain_3.identifier !== selectedChain.identifier);
      allChains.splice(visibleChainIndex - 1, 0, selectedChain);
    }
  }
  const visibleChains = allChains.slice(0, visibleChainIndex);
  const dropdownChains = allChains.slice(visibleChainIndex);
  const shouldDisableChain = chain_4 => {
    if (isAbstractWallet) {
      return chain_4.identifier !== "abstract";
    }
    return direction === "to" && fromCurrency.chainIdentifier !== chain_4.identifier && !chain_4.swapsSupported;
  };
  const isAllSelected = value === "all";
  let t2;
  if ($[2] !== className) {
    t2 = classNames("flex gap-2", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onSelectChain) {
    t3 = () => onSelectChain("all");
    $[4] = onSelectChain;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("all");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isAllSelected || $[9] !== t3 || $[10] !== t4) {
    t5 = <SwitchPill checked={isAllSelected} className="h-9 grow rounded-md" onClick={t3} value="all">{t4}</SwitchPill>;
    $[8] = isAllSelected;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = visibleChains.map(chain_5 => <Tooltip content={shouldDisableChain(chain_5) ? t("swapsNotSupported") : chain_5.name} key={chain_5.networkId}><span className="grow"><SwitchPill checked={value === chain_5.identifier} className="h-9 w-full rounded-md" disabled={shouldDisableChain(chain_5)} key={chain_5.networkId} onClick={() => onSelectChain(chain_5.identifier)} value={chain_5.identifier}><div className={classNames("relative inset-shadow-border size-[18px] rounded-full")}><Avatar {...getLogo(chain_5.identifier, {
            circle: true
          })} size={18} /></div></SwitchPill></span></Tooltip>);
  const t7 = dropdownChains.length > 0 ? <><Media greaterThanOrEqual="md"><FloatingCombobox content={<><FloatingComboboxInput onValueChange={setSearchQuery} placeholder={t("placeholder")} value={searchQuery} /><FloatingComboboxList><FloatingComboboxEmpty>{t("noResultsFound")}</FloatingComboboxEmpty>{dropdownChains.filter(c => c.name.toLowerCase().includes(searchQuery.toLowerCase())).map(chain_6 => <Tooltip content={t("swapsNotSupported")} disabled={!shouldDisableChain(chain_6)} key={chain_6.networkId}><span><FloatingComboboxItem disabled={shouldDisableChain(chain_6)} key={chain_6.networkId} onSelect={() => onSelectChain(chain_6.identifier)} value={chain_6.identifier}><FloatingComboboxItemAvatar {...getLogo(chain_6.identifier, {
                  circle: true
                })} size={20} /><FloatingComboboxItemContent><FloatingComboboxItemTitle>{chain_6.name}</FloatingComboboxItemTitle></FloatingComboboxItemContent></FloatingComboboxItem></span></Tooltip>)}</FloatingComboboxList></>} overflowLabel={t("overflowLabel")} overrides={{
        Popover: {
          align: "end",
          portal: false,
          className: "max-h-[338px]"
        }
      }} shouldFilter={false}><SwitchPill className="h-9 grow rounded-md"><MoreHoriz size={20} /></SwitchPill></FloatingCombobox></Media><Media lessThan="md"><BottomSheet content={<BottomSheetBody className="py-2">{dropdownChains.map(chain_7 => <Item className="py-2" disabled={shouldDisableChain(chain_7)} key={chain_7.networkId} onClick={() => {
          onSelectChain(chain_7.identifier);
          setIsSheetOpen(false);
        }} variant="unstyled"><ItemAvatar {...getLogo(chain_7.identifier, {
            circle: true
          })} /><ItemContent><ItemTitle>{chain_7.name}</ItemTitle></ItemContent></Item>)}</BottomSheetBody>} nested={true} onOpenChange={setIsSheetOpen} open={isSheetOpen}><SwitchPill className="h-9 grow rounded-md"><MoreHoriz size={20} /></SwitchPill></BottomSheet></Media></> : null;
  let t8;
  if ($[12] !== t2 || $[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <div className={t2}>{t5}{t6}{t7}</div>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp(chain_1) {
  return !PRIORITIZED_SWAP_CHAINS.includes(chain_1.identifier);
}